import React from 'react';
import { colors } from '../../theme';

const hexToRgba = (hex, alpha) => {
  const h = hex.replace('#', '');
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

/**
 * The photo-dissolves-into-navy scrim, as its own primitive so any hero
 * (login, workout completion, dashboard) composites a photo the same way.
 * `direction="down"` fades a top-anchored photo into the surface below it;
 * `direction="up"` is the inverse, for a bottom-anchored full-bleed photo.
 */
const ImageGradient = ({ direction = 'down', to = colors.bg, style }) => {
  const early = hexToRgba(to, 0.25);
  const mid = hexToRgba(to, 0.6);
  const late = hexToRgba(to, 0.92);
  // Darkening is held off until well past halfway so most of the photo
  // reads clearly — only the tail (where a headline sits) gets dark
  // enough for text contrast. Earlier versions darkened from 45% and
  // washed the photo out almost entirely in a short box.
  const gradient = direction === 'down'
    ? `linear-gradient(to bottom, transparent 0%, ${early} 62%, ${mid} 80%, ${late} 92%, ${to} 100%)`
    : `linear-gradient(to top, transparent 0%, ${early} 38%, ${mid} 58%, ${late} 80%, ${to} 100%)`;

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        background: gradient,
        pointerEvents: 'none',
        ...style,
      }}
    />
  );
};

export default ImageGradient;
